import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';

/*
 * Manages a transition from and initial state to an end state
 */
function flushDOM() {
  return document.body.clientHeight;
}

function applyStyles(el, styleObject) {
  Object.entries(styleObject).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        propertyName = _ref2[0],
        value = _ref2[1];

    el.style[propertyName] = typeof value === 'function' ? value() : value;
  });
}

function createCompletionPromise(el) {
  return new Promise(function (resolve, reject) {
    // We need to make available a way to reject the pending transition completion promise if a new
    // one is created, which happens if the transition is reversed!
    var cancelTransitionCallback = function cancelTransitionCallback() {
      reject(new Error('transition interrupted!'));
    };

    if (typeof el.cancelTransitionCallback === 'function') {
      // if this is present, it means a transition is already running on this, and we have just
      // reversed it, so we should call it to reject the old one's promise.
      el.cancelTransitionCallback();
    } // place the cancellation callback and add the event listener


    el.cancelTransitionCallback = cancelTransitionCallback;
    el.addEventListener('transitionend', function (event) {
      // on completion, clean up the no-longer-necessary transition callback
      delete el.cancelTransitionCallback;
      resolve(event);
    }, {
      once: true
    });
  });
}

function cssTransition(configIn) {
  var defaults = {
    skipAnimation: false,
    setup: [[null, {}]],
    from: [[null, {}]],
    to: [[null, {}]]
  }; // if we're supposed to skip the animation, we just need to fulfill the promise so the end state
  // can be realized

  var config = Object.assign({}, defaults, configIn);
  var transitionDurations = new Map(); // set setup styles in one frame

  config.setup.forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        el = _ref4[0],
        style = _ref4[1];

    if (!el) return; // record the requested transitionDuration

    transitionDurations.set(el, style.transitionDuration); // set a zero transition duration so we can apply styles in a single frame

    applyStyles(el, Object.assign(style, {
      transitionDuration: '0ms'
    }));
  }); // I once thought there needed to be a flushDOM(); here
  // set the from styles in one frame

  config.from.forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        el = _ref6[0],
        style = _ref6[1];

    if (!el) return; // Set everything *except* the transitionDuration

    var effectiveStyles = Object.assign({}, style);
    delete effectiveStyles.transitionDuration; // apply the styles in one frame

    applyStyles(el, effectiveStyles);
  }); // IE and Edge need this flushDOM here!

  flushDOM(); // set the end styles, run the animation, and return a Promise (or Promises!) that resolves when
  // it's over

  return Promise.all(config.to.map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        el = _ref8[0],
        style = _ref8[1];

    if (!el) return Promise.reject(); // set up and handle the transitionEnd callback to produce a nice clean Promise -- UNLESS the
    // skipAnimation flas is set. Then just return a fulfilled promise so any desired end state of
    // the animation can still happen through the .then()

    var promise = !config.skipAnimation ? createCompletionPromise(el) : Promise.resolve(); // restore the transition durations -- UNLESS the skipAnimation flag is set. Then it should
    // just stay at zero.

    var effectiveStyles = !config.skipAnimation ? Object.assign({}, style, {
      transitionDuration: transitionDurations.get(el)
    }) : style; // create the completion promise and run the animation!

    applyStyles(el, effectiveStyles);
    return promise;
  }));
}

export { flushDOM, cssTransition };
